# This directive prevents scrolling of outer DOM elements if scrolling reaches borders in inner element.
# Usage: <ul class="options-list" prevent-outer-scroll>
angular.module('rjmNg.directives').directive "preventOuterScroll", [
  () ->
    restrict: "A"
    link: (scope, element, attr) ->

      _eventHandler = (event) ->
        if (element.scrollTop() is element[0].scrollHeight - element.innerHeight() and
          event.originalEvent.deltaY > 0) or
          (element.scrollTop() is 0 and
          event.originalEvent.deltaY < 0)
            event.preventDefault()

      element.on('wheel', _eventHandler)

      _cleanUp = () ->
        element.off('wheel', _eventHandler)
        return

      scope.$on('$destroy', _cleanUp)
]